/** What each storage tier holds, as the storage pages name it. */
export const TIER_LABEL: Record<string, string> = { originals: 'Hi-res originals', derivatives: 'Proxies & previews', collateral: 'Collateral', exports: 'Exports' };
